// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"113":"47d1b8bb","138":"07fdf7d9","284":"23b9af09","323":"5b584842","394":"ca9d14b1","517":"599a5c45","521":"c3d48219","761":"ec643b4e","898":"4ea12c91"}[chunkId] + ".js";
};